import {Image, List, Modal, Skeleton} from 'antd';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

const LowStockModal = ({isModalOpen, setIsModalOpen, lowStockProducts = [], isLoading}) => {
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);
  const navigate = useNavigate();

  return (
    <Modal
      title={'Products Low in Stock'}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={700}
      bodyStyle={{
        maxHeight: '400px',
        overflowY: 'auto',
      }}>
      {isLoading ? (
        <Skeleton active />
      ) : lowStockProducts.length === 0 ? (
        <p>No products are low in stock 🎉</p>
      ) : (
        <List

          itemLayout={'horizontal'}
          dataSource={lowStockProducts}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                avatar={<Image preview={false} width={50} src={item.imageUrl?.[0]} />}
                title={<b>{item.productName}</b>}
                onClick={() => navigate('/team/product')}
                description={(
                  <p>
                                        Sizes low in stock:{' '}
                    {item.size
                      .filter(s => parseInt(s.quantity) <= 5)
                      .map(s => `Size ${s.size} (Qty: ${s.quantity})`)
                      .join(', ')}
                  </p>
                )}
              />
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
};

LowStockModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  lowStockProducts: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
};

export default LowStockModal;
